import { render, staticRenderFns } from "./SensitiveWords.vue?vue&type=template&id=c6f57f72&scoped=true"
import script from "./SensitiveWords.vue?vue&type=script&lang=js"
export * from "./SensitiveWords.vue?vue&type=script&lang=js"
import style0 from "./SensitiveWords.vue?vue&type=style&index=0&id=c6f57f72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6f57f72",
  null
  
)

export default component.exports